import React, { useRef, useEffect, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { COLORS } from "utils/styles";
import getConfig from "next/config";

import netlifyAuth from "../netlifyAuth.js";

const COLLECTION_TYPES = [
  {
    folderPath: "_mediaArtifacts",
    adminPath: "mediaArtifact",
  },
];

const Link = styled.a`
  margin: 0 auto;
  display: flex;
  color: ${COLORS.BLACK};
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  background-color: white;
  opacity: 0.5;

  &:hover {
    text-decoration: none;
    opacity: 1;
  }
`;

export default function EditLink({ filePath }) {
  let [loggedIn, setLoggedIn] = useState(netlifyAuth.isAuthenticated);

  useEffect(() => {
    netlifyAuth.initialize((user) => {
      setLoggedIn(!!user);
    });
  }, [loggedIn]);

  const setParentStyle = () => {
    if (!linkRef || !linkRef.current) return;

    const parent = linkRef.current.parentElement;

    if (parent.style.position !== "") return;

    parent.style.position = "relative";
  };

  useEffect(() => {
    setParentStyle();
  }, []);

  const { publicRuntimeConfig } = getConfig();

  const linkRef = useRef(null);

  if (!publicRuntimeConfig.editingEnabled) return null;
  if (!loggedIn) return null;

  if (!filePath) return null;

  const [collectionTypeFolderPath, fileName] = filePath
    .split(/[\/\.]/g)
    .filter((s) => s !== "");
  const collectionType = COLLECTION_TYPES.find(
    ({ folderPath }) => folderPath === collectionTypeFolderPath
  );

  const collectionTypePath = collectionType
    ? collectionType.adminPath
    : collectionTypeFolderPath.substring(1);

  const editURL = ["collections", collectionTypePath, "entries", fileName].join(
    "/"
  );

  return (
    <Link href={`/admin/#/${editURL}`} ref={linkRef}>
      <i className="material-icons-round md-18">edit</i>
      <span>Edit</span>
    </Link>
  );
}
